<template>
	<div>
		<el-row class="home" :gutter="20">
			<el-col :span="8" style="text-align: left;">
				<div id="svgBox">
					<div id="svgTop">
						<div id="sc" :style="{ height: tableHeight + 'px' }"  style="margin-top:5px;padding:5px;border:2px solid #E4E7ED">
							<el-divider content-position="center">{{$t('getapi[12671]')}}</el-divider>

							<!-- <el-tag
                                v-for="tag in dataSet"
                                :key="tag.website_name"
                                closable
                                @close="handleDelete(tag)"
                                @click="jumpto(tag)"
                                margin-right=8px
                                :type="tag.type == 1 ? '' : 'success'">
                                {{tag.website_name}}
                            </el-tag> -->
							<!-- <el-button @click="dialogVisible = true" class="addfav">添加</el-button> -->
							<div>
								<el-button size="mini" type="primary" plain @click="dialogVisible=true">{{$t('getapi[4412]')}}</el-button>
								<!--<el-button size="mini" type="primary" plain @click="saveFavorites">{{$t('getapi[937]')}}</el-button>-->
							</div>

								<!--<el-table :data="dataSet"
										  style="width: 100%"
										  v-loading="loading"
										  show-overflow-tooltip="true"
										  :show-header="false"
										  header-cell-class-name="table_header"
										  :row-style="{height:'20px'}"
										  :cell-style="{padding:'2px'}"
										  class="favorites_table">
									<el-table-column show-overflow-tooltip prop="website_id" label="网站id" v-if=false></el-table-column>
									&lt;!&ndash; <el-table-column label="    " :render-header="renderHeader"> &ndash;&gt;
									<el-table-column label="网站">
										<template slot-scope="jumpscope">
											<div>m
									<span v-if="jumpscope.row.type==1">
										<img :src="jumpscope.row.imglogin"  @error="e => { e.target.src =defimg }"  alt="" width="20px" height="20px" class="favicon">
									</span>
												<span v-else>
										<img src="../../assets/img/logo.png" alt="" width="20px" height="20px" class="favicon">
									</span>
												&lt;!&ndash; <img src="../../assets/img/logo.png" alt="" width="20px" height="20px" class="favicon" v-if="jumpscope.row.type == 0"> &ndash;&gt;
												<el-button size="small" border="0px" @click="jumpto(jumpscope.row)" :type="jumpscope.row.type == 1 ? ' ' : 'success'" plain class="jumpto"><span>{{jumpscope.row.website_name}}</span></el-button>

											</div>
										</template>
									</el-table-column>
									<el-table-column show-overflow-tooltip prop="website_address" label="网址" v-if=false></el-table-column>
									<el-table-column prop="type" label="网站类型" v-if=false>
										<template #default="scope">
											<span>{{scope.row.type == 0 ? '内部网站' : '外部网站'}}</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" align="right" width="30px">
										<template slot-scope="scope">
											&lt;!&ndash; <el-button size="mini" @click="handleDelete(scope.row)" :type="scope.row.type == 1 ? 'primary' : 'success'" plain>删除</el-button> &ndash;&gt;
											<el-button size="mini" :type="scope.row.type == 1 ? ' ' : 'success'" plain @click="handleDelete(scope.row)" icon="el-icon-delete" circle></el-button>
										</template>
									</el-table-column>
								</el-table>-->
								<vxe-table :data="dataSet"
										   row-key
										  style="width: 100%"
										  v-loading="loading"
										  show-overflow-tooltip="true"
										  :show-header="false"
										  header-cell-class-name="table_header"
										  :row-style="{height:'20px'}"
										  :cell-style="{padding:'2px'}"
										  class="sortable-row-demo"
									      row-class-name="drag-btn"
										  ref="xTable1"
									      :height="tableHeight - 60"
								>
									<vxe-table-column show-overflow-tooltip field="website_id" title="网站id" v-if=false></vxe-table-column>
									<!-- <vxe-table-column title="    " :render-header="renderHeader"> -->
									<vxe-table-column title="网站">
										<template slot-scope="jumpscope">
											<div>
									<span v-if="jumpscope.row.type==1">
										<img :src="jumpscope.row.imglogin"  @error="e => { e.target.src =defimg }"  alt="" width="20px" height="20px" class="favicon">
									</span>
												<span v-else>
										<img src="../../assets/img/logo.png" alt="" width="20px" height="20px" class="favicon">
									</span>
												<!-- <img src="../../assets/img/logo.png" alt="" width="20px" height="20px" class="favicon" v-if="jumpscope.row.type == 0"> -->
												<el-button size="small" border="0px" @click="jumpto(jumpscope.row)" :type="jumpscope.row.type == 1 ? ' ' : 'success'" plain class="jumpto"><span>{{jumpscope.row.website_name}}</span></el-button>

											</div>
										</template>
									</vxe-table-column>
									<vxe-table-column show-overflow-tooltip field="website_address" title="网址" v-if=false></vxe-table-column>
									<vxe-table-column field="type" title="网站类型" v-if=false>
										<template #default="scope">
											<span>{{scope.row.type == 0 ? '内部网站' : '外部网站'}}</span>
										</template>
									</vxe-table-column>
									<vxe-table-column title="操作" align="right" width="100px" fixed="right">
										<template slot-scope="scope">
											<!-- <el-button size="mini" @click="handleDelete(scope.row)" :type="scope.row.type == 1 ? 'primary' : 'success'" plain>删除</el-button> -->
											<el-button size="mini" plain @click="editWebsite(scope.row)" icon="el-icon-edit" circle></el-button>
											<el-button size="mini" :type="scope.row.type == 1 ? ' ' : 'success'" plain @click="handleDelete(scope.row)" icon="el-icon-delete" circle></el-button>
										</template>
									</vxe-table-column>
								</vxe-table>

						</div>
					</div>
					<div id="svgResize"></div>
					<div id="svgDown" style="border-top: 1px solid #b5b9a9;">
						<div id="xx" :style="{ height: tableHeight1 + 'px' }" style="margin-top:5px;padding:5px;border:2px solid #E4E7ED">
							<el-divider content-position="center" @click="getMsgInfo">
								<el-badge :value="$root.MyMsg" class="item" v-if="$root.MyMsg > 0">
									{{$t('getapi[12672]')}}
								</el-badge>
								<span v-if="$root.MyMsg == 0">{{$t('getapi[12672]')}}</span>
							</el-divider>
							<div>
								<el-button type="primary" size="mini" plain :disabled="selectIDData.length<1"  @click="delMsg">{{$t('getapi[656]')}}</el-button>
							</div>
							<div>
								<el-table :data="dataMsgSet"
										  style="width: 100%"
										  show-overflow-tooltip="true"
										  header-cell-class-name="table_header"
										  class="favorites_table"
										  @row-click="readMsg"
										  @selection-change="handleSelectionChange"
										  :header-cell-style="$limits.headerClass"
										  :row-style="{height:'20px'}"
										  :cell-style="{padding:'5px 0px'}"
										  :height="tableHeight1 - 60"
										  border
								>
									<el-table-column align="center" type="selection" width="20"></el-table-column>
									<el-table-column width="25">
										<template slot-scope="scope">
											<div>
										<span v-if="scope.row.isSee==0">
											<img src="../../assets/img/wd.png" width="20px" height="20px" class="favicon">
										</span>
												<span v-else>
											<img src="../../assets/img/yd.png" width="20px" height="20px" class="favicon">
										</span>
											</div>
										</template>
									</el-table-column>
									<el-table-column show-overflow-tooltip prop="MsgTitle" :label="$t('getapi[2551]')">
										<template slot-scope="scope">
											<span v-if="scope.row.isSee==0" style="font-weight:bold;font-size: 12px">{{scope.row.MsgTitle}}(<span style="color: red">{{scope.row.unreadrecord}}</span>条未读)</span>
											<span v-else style="font-size: 12px">{{scope.row.MsgTitle}}</span>
										</template>
									</el-table-column>
									<!--<el-table-column show-overflow-tooltip prop="SendMan" label="发件人" width="50">
										<template slot-scope="scope">
											<span style="font-size: 12px">{{scope.row.SendMan}}</span>
										</template>
									</el-table-column>-->
									<el-table-column show-overflow-tooltip prop="SendTime" :label="$t('getapi[12673]')" width="80">
										<template slot-scope="scope">
											<span style="font-size: 12px">{{scope.row.SendTime | timeFormat}}</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="16" style="text-align: center;">
				<div v-if="showP">
					<el-image :src="src" lazy fit="contain">
						<div slot="placeholder" class="image-slot">
							{{$t('getapi[12674]')}}
							<span class="dot">...</span>
						</div>
					</el-image>
				</div>
				<div v-if="!showP" style="display: flex;width:100%;flex-wrap: wrap">
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="showCalendar">
						<el-calendar v-model="selectdate"  ref="calendarRef">
							<template
									slot="dateCell"
									slot-scope="{date, data}">
								<div style="position: relative;text-align: center;height:100%">
									<span style="font-size: 20px">{{data.day.split('-').slice(2)[0]}}</span>
									<div v-for="item in calendardata"  v-bind:key="item.cd_date">
										<div style="font-size: 12px;margin-top: 2px;position: relative;z-index:9" v-if="data.day.split('-').slice(2)[0] == item.lunar.solarDay && checkList.length == 1" class="lunar">
                                            <span v-if="item.lunar.festival" >
                                                {{item.lunar.festival}}
                                            </span>
											<span v-else>
                                                {{item.lunar.dayDisplay}}
                                            </span>
										</div>
										<div v-if="data.day.split('-').slice(1)[0] == item.month && data.day.split('-').slice(0)[0] == item.year">
											<div v-if="data.day.split('-').slice(2)[0] == item.day && item.day_status == 1"  style="width:100%;position:absolute;top:0;left:0;height:100%">
												<span style="font-size: 20px">{{data.day.split('-').slice(2)[0]}}</span>
											</div>
											<div v-if="data.day.split('-').slice(2)[0] == item.day && item.day_status != 1" class="offfont" style="width:100%;position:absolute;top:0;left:0;height:100%">
												<span style="font-size: 20px">{{data.day.split('-').slice(2)[0]}}</span>
											</div>
										</div>
										<div v-else></div>
									</div>
								</div>
							</template>
						</el-calendar>
						<div>
							<tr>
								<td style="width:50px">{{$t('getapi[4070]')}}</td>
								<td style="width:50px">{{$t('getapi[4049]')}}</td>
								<td style="width:50px"><div style="width:30px;height:10px" class="off"></div></td>
								<td style="width:50px">{{$t('getapi[4050]')}}</td>
								<td style="width:50px"><div style="width:30px;height:10px" class="work"></div></td>
							</tr>
						</div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('会议') !== -1">
						<el-divider content-position="center" @click="getMsgInfo">
							<span>{{'我的会议'}}</span>
						</el-divider>
						<el-carousel :autoplay="false" type="card">
							<el-carousel-item v-for="(item,index) in dataMeeting" :key="item"
											  :style="{
								backgroundColor: (index === 0 && item.conf_room != '暂无会议') ? '#ffcbba' : '#d3dce6'
							  }">
								<div style="padding:3px 3%;width:100%;height:100%;display:flex;justify-content:center;align-items:center">
									<div class="meeting-card"  @dblclick="toMeetingRoom(item)">
										<div class="card-header">
											<h2>{{item.conf_room}}</h2>
										</div>
										<div class="card-content">
											<div class="info-row theme">
												<div class="icon">
													<i class="fas fa-bullhorn"></i>
												</div>
												<div class="info-content">
													<div class="info-label">会议主题</div>
													<div class="info-value">{{item.conf_theme}}</div>
												</div>
											</div>

											<div class="info-row time">
												<div class="icon">
													<i class="far fa-clock"></i>
												</div>
												<div class="info-content">
													<div class="info-label">会议时间</div>
													<div class="info-value">{{item.conf_date}}</div>
												</div>
											</div>

											<div class="info-row person">
												<div class="icon">
													<i class="fas fa-user"></i>
												</div>
												<div class="info-content">
													<div class="info-label">预定人</div>
													<div class="info-value">{{item.appt_person}}</div>
												</div>
											</div>

											<div class="info-row phone">
												<div class="icon">
													<i class="fas fa-phone-alt"></i>
												</div>
												<div class="info-content">
													<div class="info-label">电话</div>
													<div class="info-value">{{item.appt_tel}}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('强关工单') !== -1">
							<div id="main_qggd" :style="{ width: '100%', 'height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px' }"></div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('用料成本差异') !== -1">
						<div id="main_ylcb" :style="{ width: '100%', 'height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px'}"></div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('活跃物料数量') !== -1">
						<div id="main_hywl" :style="{ width: '100%','height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px'}"></div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('OEE') !== -1">
						<div id="main_oee" :style="{ width: '100%','height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px' }"></div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('板材利用率') !== -1">
						<div id="main_bcly" :style="{ width: '100%', 'height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px'}"></div>
					</div>
					<div :style="{'width': checkList.length <= 2 ? '100%':'49%',
					'height':checkList.length == 1?'100%':tableHeight2 + 'px'}"
						 v-if="checkListStr.indexOf('DPPM') !== -1">
						<div id="main_dppm" :style="{ width: '100%', 'height':checkList.length == 1?2*tableHeight2+'px' : tableHeight2 + 'px' }"></div>
					</div>

				</div>
				<div style=" position: absolute;top: 2px;right:2px;">
					<el-popover
							placement="right"
							width="200"
							trigger="click"
							v-model="setvisible">
						<el-checkbox-group v-model="checkList" :max="4" @change="changeECharts">
							<el-checkbox label="会议" style="display: block" v-if="Login_DB == 'JM'"></el-checkbox>
							<el-checkbox label="日历" style="display: block"></el-checkbox>
							<el-checkbox label="强关工单" style="display: block" :disabled="$limits.authority('plv2', 545, 1) == 0"></el-checkbox>
							<el-checkbox label="用料成本差异" style="display: block" :disabled="$limits.authority('plv2', 546, 1) == 0"></el-checkbox>
							<el-checkbox label="活跃物料数量" style="display: block" :disabled="$limits.authority('plv2', 547, 1) == 0"></el-checkbox>
							<el-checkbox label="OEE" style="display: block"></el-checkbox>
							<el-checkbox label="板材利用率" style="display: block"></el-checkbox>
							<el-checkbox label="DPPM" style="display: block"></el-checkbox>
						</el-checkbox-group>
						<div style="text-align: right; margin: 0">
							<el-button size="mini" type="text" @click="setvisible = false">取消</el-button>
							<el-button type="primary" size="mini" @click="confirmSetting">保存</el-button>
						</div>
						<el-button size="small" slot="reference" icon="el-icon-setting" circle></el-button>
					</el-popover>
				</div>
				<!--<div style="display: flex;width:100%">
					<div id="main" :style="{ width: '49%', height: tableHeight + 'px' }"></div>
					<div id="main1" :style="{ width: '49%', height: tableHeight + 'px' }"></div>
				</div>
				<div style="display: flex;width:100%">
					<div id="main2" :style="{ width: '49%', height: tableHeight + 'px' }"></div>
					<div id="main3" :style="{ width: '49%', height: tableHeight + 'px' }"></div>
				</div>-->
			</el-col>
		</el-row>
		<!-- 添加弹框 -->
		<el-dialog :title="$t('getapi[12675]')" :visible.sync="dialogVisible" min-width=400px width=18%>
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[12676]')}}</td>
					<td><el-input v-model="addData.name" type="text" size="mini" ></el-input></td>
                </tr>
				<tr>
					<td>{{$t('getapi[12677]')}}</td>
					<td><el-input v-model="addData.address" type="text" size="mini"></el-input></td>
                </tr>
				<tr>
                    <td>{{$t('getapi[12678]')}}</td>
					<td><el-select v-model="addData.type">
                            <el-option :label="$t('getapi[12679]')" value="outside"></el-option>
                            <el-option :label="$t('getapi[12680]')" value="inside"></el-option>
                        </el-select>
					</td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">{{$t('getapi[2054]')}}</el-button>
                <el-button size="small" type="primary" @click="saveadd">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

		<el-dialog :title="$t('getapi[34]')" :visible.sync="editVisible" min-width=400px width=18%>
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr >
						<td>{{$t('getapi[12676]')}}</td>
						<td><el-input v-model="editData.website_name" type="text" size="mini" style="width:100%"></el-input></td>
					</tr>
					<tr v-show="editData.type == 1">
						<td>{{$t('getapi[12677]')}}</td>
						<td><el-input v-model="editData.website_address" type="text" size="mini" style="width:100%"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
                <el-button size="small" @click="editVisible = false">{{$t('getapi[2054]')}}</el-button>
                <el-button size="small" type="primary" @click="confirmEditWebsite">{{$t('getapi[1146]')}}</el-button>
            </span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="msgVisiable" width="70%">
			<div style="height: 500px;margin-top: 15px;line-height: 25px">
				<div style="text-align: center;margin-bottom: 8px">
					<span style="color:green;font-size: 25px;">{{msgDetail.MsgTitle}}</span>
				</div>
				<div id="help">
					<div style="padding: 40px 60px;width:100%;height:100%;">
						<div style="width:100%;height:100%;overflow-y: auto">
							<span v-html="msgDetail.MsgInfo"></span>
						</div>
					</div>
				</div>
			</div>
			<el-table
					id="bzqaqyjyc"
					:data="dataAQYJ"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					height="500"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
					v-if="false"
			>
				<el-table-column type="selection" v-if="false"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Stock_LowerLimit" align="right" :label="$t('getapi[2548]')">
					<template slot-scope="scope">
						{{scope.row.Stock_LowerLimit | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="sum_onhand" align="right" :label="$t('getapi[2573]')">
					<template slot-scope="scope">
						{{scope.row.sum_onhand | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="sum_OrderOnQty" align="right" :label="$t('getapi[2574]')">
					<template slot-scope="scope">
						{{scope.row.sum_OrderOnQty | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="Diff_Qty" align="right" :label="$t('getapi[2575]')">
					<template slot-scope="scope">
						{{scope.row.Diff_Qty | thousandth}}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="aqyjVisiable" width="70%" :close-on-click-modal="false">
			<el-button size="mini" type="primary" @click="expAQYJ">{{$t('getapi[3629]')}}</el-button>
			<el-table
					id="bzqaqyj"
					:data="dataAQYJ"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					height="500"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
			>
				<el-table-column type="selection" v-if="false"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Stock_LowerLimit" align="right" :label="$t('getapi[2548]')">
					<template slot-scope="scope">
						{{scope.row.Stock_LowerLimit | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="sum_onhand" align="right" :label="$t('getapi[2573]')">
					<template slot-scope="scope">
						{{scope.row.sum_onhand | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="sum_OrderOnQty" align="right" :label="$t('getapi[2574]')">
					<template slot-scope="scope">
						{{scope.row.sum_OrderOnQty | thousandth}}
					</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="Diff_Qty" align="right" :label="$t('getapi[2575]')">
					<template slot-scope="scope">
						{{scope.row.Diff_Qty | thousandth}}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
import Sortable from 'sortablejs';
import defimg from '@/assets/img/login/log.png';
import FileSaver from "file-saver";
import XLSX from "xlsx"
import Common from '@/components/Common';
import echarts from 'echarts';
import 'echarts-gl';
import { mapActions } from 'vuex'
// import Mock from 'mockjs';
export default {
    name: 'home',
	data() {
		return {
			defimg,
            tableHeight: (window.innerHeight - 160) /2,
            tableHeight1: (window.innerHeight - 160) /2,
            tableHeight2: (window.innerHeight - 160) /2,
			src:"",
			language:'',
            instanceName: '',
            getHeart: null,
			dataSet: [], // 主表数据
			loading: false, // 主表加载状态
			dialogVisible:false,// 添加弹框是否可见
			addData: {
                name: '',
				address:'',
                type: '',
			},
			editData:{
                website_id:'',
                website_address:'',
				website_name :'',
				type :'',
				login_num :'',
				login_name :'',
				pagename:'',
				colsort:'',
			},
			userData:[],
            Login_DB:'',
			token:'',
            dataMsgSet:[],
			msgDetail:{
                num:'',
                MsgTitle:'',
                MsgInfo:'',
				SendMan:'',
				SendTime:'',
				ReceiveMan:'',
				isSee:0,
				isdelete:0
			},
			msgVisiable: false,
            selectIDData:'',
            aqyjVisiable: false,
            dataAQYJ:[],
            editVisible: false,

            setvisible:false,
            checkList: [],
            checkListStr:'',
            showP:true,
			//日历
            selectdate: new Date(), //日历显示的日期
            calendardata: [], //日历明细数据
            calendarListenersBound: false, // 标记监听器是否已绑定
			//会议室
            dataMeeting:[],
		};
	},
	computed:{
        showCalendar() {
            return this.checkListStr && this.checkListStr.indexOf('日历') !== -1;
        }
	},
	watch: {
		"$i18n.locale": function(e) {
			this.setOptions(JSON.stringify(e));
		},
        showCalendar(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.bindCalendarEvents();
                });
            }
        },
	},
	created:function(){
        let that = this
        that.$http.urlpost('/Sys/Currency/GetCompanyInfo', '', function(res) {
            if (res.Success == 1) {
                if(res.DataContent.windowstyle == 1 || res.DataContent.windowstyle == 2 || res.DataContent.windowstyle == 3 || res.DataContent.windowstyle == 4){
                    that.$root.windowstyle = res.DataContent.windowstyle
                } else {
                    that.$root.windowstyle = 1
                }
            }
        });
        that.loadDigitSettings()
	},
    mounted: function () {
        let that = this;
        that.dragControllerDivPortrait();
        that.instanceName = JSON.parse(sessionStorage.getItem('userData')).Login_Instance
		that.userData = sessionStorage.getItem('userData');
        that.Login_DB = JSON.parse(sessionStorage.getItem('userData')).Login_DB
		/*that.executeHeart();*/
		that.language=window.localStorage.getItem('lang');
		that.setOptions(that.language);
        that.getHeart = setInterval(() => {
            that.getMsgInfo();
        }, 120000);
		that.getView()
		that.getMsgInfo();
        that.rowDrop();
        that.getHomeC();
        if (this.showCalendar) {
            this.$nextTick(() => {
                this.bindCalendarEvents();
            });
        }
    },
    beforeDestroy(){
        console.log('关闭')
        clearInterval(this.getHeart)
        this.getHeart = null
        if (this.sortable1) {
            this.sortable1.destroy();
        }
        this.calendarListenersBound = false;
    },
	methods: {
        ...mapActions('digitsetting', ['loadDigitSettings']),
		getView() {
			let that = this;
			that.loading = true;
			let data = {
			};
			if(that.userData!=null){
				that.$http.urlpost('/User/SYS_Users/FavoritesList', data, function (res) {
					if (res.Success == 1) {
						that.dataSet = res.DataContent;
						for(let i = 0;i<that.dataSet.length;i++){
						    if(that.dataSet[i].type == 1){
                                that.dataSet[i].imglogin =  that.getRegUrl(that.dataSet[i].website_address) + '/favicon.ico'
								console.log(that.dataSet[i].imglogin)
							}
						}
						that.loading = false;
					}
				});
			}
		},
		jumpto(tag){
			if(tag.type == 1){
				window.open(tag.website_address, '_blank')
			}
			else{
				let item = {
					path: tag.website_address.slice(1),
					name: tag.pagename,
					label: tag.website_name,
					icon: "arrow-right"
				}
				let keep = [];
				if (
					sessionStorage.getItem("keepview") != null &&
					sessionStorage.getItem("keepview").length > 0
				) {
				keep = JSON.parse(sessionStorage.getItem("keepview"));
				}

				if (keep.indexOf(item.name) < 0) {
					keep.push(item.name);
					sessionStorage.setItem("keepview", JSON.stringify(keep));
					this.$forceUpdate();
				}
				this.$router.push(item).then((val) => {
					if (val.name == item.name) {
						this.$store.commit("selectMenu", item);
					}
				});
				// this.$store.commit("selectMenu", item);
				// window.open("http://" +window.location.host + '//' + tag.website_address, '_self')
			}
		},
		saveadd(){
			let that = this
			let parm = {
				website_name:that.addData.name,
				type: that.addData.type == 'outside' ?1:0,
				website_address:that.addData.address,
			}
			that.$http.urlpost('/User/SYS_Users/SaveFavorites', parm, function (res) {
				if (res.Success == 1) {
					alert("添加成功！")
					that.addData.name=''
					that.addData.address=''
					that.addData.type= ''
					that.dialogVisible=false
					that.getView()
				} else {
					alert("出问题了！")
				}
			});
		},
		handleDelete(tag) {
			let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    let parm = {
                        website_id:tag.website_id,
                    }
                    that.$http.urlpost('/User/SYS_Users/DeleteFavorites', parm, function (res) {
                        if (res.Success == 1) {
                            alert("删除成功！")
                            that.getView()
                        } else {
                            alert("出问题了！")
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
			//this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		},
        /*() {
            let that = this
            setInterval(() => {
                that.$http.urlpost('/User/SYS_Users/LoginHeartBeat', '', function (res) {
                    if (res.Success == 1) {
                        console.log('心跳~~~')
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            }, 120000);
		},*/
		setOptions(val){
			let that = this;
			if(val=='en'){
				that.src= require('../../assets/img/en_home.png');
			}
			else{
				that.src= require('../../assets/img/home.png')
			}
		},
		renderHeader () {
			return (
				<div>
				<el-button class="addfav" size="mini" type="primary">添加</el-button>
				</div>
			)
		},
		// showfilters(){
		// 	this.dialogVisible = true;
		// }
		// 获取消息列表
        getMsgInfo(){
		  	let that = this
            let parm = {}
            that.$http.urlpost('/Sys/Currency/getMsgInfo', parm, function(res) {
                if (res.Success == 1) {
                    that.dataMsgSet = res.DataContent
					that.getAllWdMsg()
                }
            });
		},
        getAllWdMsg(){
            let that = this
            let parm = {}
            that.$http.urlpost('/Sys/Currency/GetAllWdMsg', parm, function(res) {
                if (res.Success == 1) {
                    that.$root.MyMsg = res.DataContent
                }
            });
        },
        readMsg(row){
		  	let that = this
			that.msgDetail = row
			that.msgVisiable = true
			let parm = {
		  	    Code: row.num
			}
            that.$http.urlpost('/Sys/Currency/readMsg', parm, function(res) {
                if (res.Success == 1) {
                    that.getMsgInfo()
                    setTimeout(() => {
                        console.log(document.getElementsByClassName('ecn'))
                        if(document.getElementsByClassName('ecn')){
                            let list=document.getElementsByClassName('ecn')
							for(let i =0;i<list.length;i++){
							    let id = Math.random()
								list[i].setAttribute('id',id)
                                document.getElementById(id).addEventListener('click',e=>{
                                    e.stopPropagation()
                                    let val = document.getElementById(id).innerHTML
                                    that.toECN(val)
									that.readMsgInfo(row.num,val)
                                })
							}
						}
                        if(document.getElementsByClassName('purorder')){
                            let list=document.getElementsByClassName('purorder')
                            for(let i =0;i<list.length;i++){
                                let id = Math.random()
                                list[i].setAttribute('id',id)
                                document.getElementById(id).addEventListener('click',e=>{
                                    e.stopPropagation()
                                    let val = document.getElementById(id).innerHTML
                                    that.toPurOrder(val)
                                    that.readMsgInfo(row.num,val)
                                })
                            }
                        }
                        if(document.getElementsByClassName('mrb')){
                            let list=document.getElementsByClassName('mrb')
                            for(let i =0;i<list.length;i++){
                                let id = Math.random()
                                list[i].setAttribute('id',id)
                                document.getElementById(id).addEventListener('click',e=>{
                                    e.stopPropagation()
                                    let val = document.getElementById(id).innerHTML
                                    that.toMRB(val)
                                    that.readMsgInfo(row.num,val)
                                })
                            }
                        }
                        if(document.getElementById('wl')){
                            document.getElementById('wl').addEventListener('click',e=>{
                                e.stopPropagation()
                                that.toMaterials('0000000')
                            })
						}
                        if(document.getElementById('aqyj')){
                            document.getElementById('aqyj').addEventListener('click',e=>{
                                e.stopPropagation()
                                that.getInvPartView()
                            })
						}
                        if(document.getElementById('aqyjxz')){
                            document.getElementById('aqyjxz').addEventListener('click',e=>{
                                e.stopPropagation()
                                that.downloadInvPartView()
                            })
                        }
                    }, 1000)
                }
            });
		},
		//读取数据后标记
		readMsgInfo(code,val){
		    let that = this
            let parm = {
				Code:code,
				Name:val,
            }
            that.$http.urlpost('/Sys/Currency/readMsgInfo', parm, function(res) {
				console.log('已读')
            });
		},
        handleSelectionChange(val) {
            let that = this;
            that.selectIDData = '';
            for (let i = 0; i < val.length; i++) {
                that.selectIDData += val[i].num + ',';
            }
        },
        delMsg() {
            let that = this;
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    that.selectIDData = that.selectIDData.substring(0,that.selectIDData.length - 1)
                    let parm = {
                        ids: that.selectIDData
                    };
                    that.$http.urlpost('/Sys/Currency/delMsgByID', parm, function(res) {
                        that.getMsgInfo()
                        that.$message.success(that.$t('getapi[659]'));
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
        },
        // 上下拖动
        dragControllerDivPortrait() {
            let that = this
            var svgResize = document.getElementById("svgResize");
            var svgTop = document.getElementById("svgTop");
            var svgDown = document.getElementById("svgDown");
            var svgBox = document.getElementById("svgBox");
            let allheight = svgBox.clientHeight
			let moveLen = ''
            svgResize.onmousedown = function (e) {
                var startY = e.clientY;
                svgResize.top = svgResize.offsetTop;
                document.onmousemove = function (e) {
                    var endY = e.clientY;
                    moveLen = svgResize.top + (endY - startY);
                    var maxT = allheight - svgResize.offsetHeight;
                    if (moveLen < 30) moveLen = 30;
                    if (moveLen > maxT - 30) moveLen = maxT - 30;
                    svgResize.style.top = moveLen;
                    svgTop.style.height = moveLen + "px";
                    svgDown.style.height = (allheight - moveLen - 5) + "px";
                    document.getElementById('sc').style.height = moveLen -6 + 'px'
                    document.getElementById('xx').style.height = (allheight - moveLen - 15) + 'px'
                }
                document.onmouseup = function (evt) {
                    that.tableHeight =  moveLen -6
					that.tableHeight1 = (allheight - moveLen - 25)
                    document.onmousemove = null;
                    document.onmouseup = null;
                    svgResize.releaseCapture && svgResize.releaseCapture();
                }
                svgResize.setCapture && svgResize.setCapture();
                return false;
            }
        },
        toMaterials(val){
            let that = this
            that.$store.commit('setSharedParams', {
                Part_Code: val
            });
            let item = {
                label: this.$t("getapi[56]"),
                name: 'mater',
                path: '/mater',
                url: '/mater',
                icon: 'video-play'
            };
            this.$router.push({ path: '/mater'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
        },
        toECN(val){
            let that = this
            that.$store.commit('setSharedParams', {
                code: val
            });
            let item = {
                label: this.$t("getapi[6125]"),
                name: 'ecnlist',
                path: '/ecnlist',
                url: '/ecnlist',
                icon: 'video-play'
            };
            this.$router.push({ path: '/ecnlist'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		},
        toPurOrder(val){
            let that = this
            that.$store.commit('setSharedParams', {
                code: val
            });
            let item = {
                label: this.$t("getapi[103]"),
                name: 'purorderview',
                path: '/purorderview',
                url: '/purorderview',
                icon: 'video-play'
            };
            this.$router.push({ path: '/purorderview'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		},
        toMRB(val){
            let that = this
            that.$store.commit('setSharedParams', {
                BillCode: val
            });
            let item = {
                label: this.$t("getapi[8508]"),
                name: 'mrbview',
                path: '/mrbview',
                url: '/mrbview',
                icon: 'video-play'
            };
            this.$router.push({ path: '/mrbview'});
            this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
        },
		getInvPartView(){
            let that = this;
            let datac = [];
            let data = {
                PageIndex: 1,
                PageSize: 10000,
                Param: datac
            };
            that.$http.urlpost('/Inv/Manager/InvPartView', data, function(res) {
                if (res.Success == 1) {
                    that.aqyjVisiable = true
                    that.dataAQYJ = res.DataContent;
                }
            });
		},
        expAQYJ() {
            let that = this
            let wb = XLSX.utils.table_to_book(document.querySelector('#bzqaqyj'),{raw:true});   // 这里就是表格

            for(let obj in wb.Sheets.Sheet1){
                if(!isNaN(wb.Sheets.Sheet1[obj].v)){
                    wb.Sheets.Sheet1[obj].v = wb.Sheets.Sheet1[obj].v.toString().replace(/\d+/, function(n){ // 先提取整数部分
                        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                            return $1+",";
                        });
                    })
                }
            }
            let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
            try {
                FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), "保质期安全预警"+'.xlsx');  //table是自己导出文件时的命名，随意
            } catch (e)
            {
                if (typeof console !== 'undefined')
                    console.log(e, wbout)
            }
            return wbout
        },
		// 拖拽
        rowDrop() {
            let that=this;
            that.$nextTick(() => {
                const xTable = that.$refs.xTable1;
                that.sortable1 = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                    handle: '.drag-btn',
                    onEnd: ({ newIndex, oldIndex }) => {
                        const currRow = that.dataSet.splice(oldIndex, 1)[0];
                        that.dataSet.splice(newIndex, 0, currRow);
                        for (let i = 0; i < that.dataSet.length; i++) {
                            that.dataSet[i].colsort=i+1;
                        }
                        that.saveFavorites()
                    }
                });
            });
        },
		// 保存收藏夹
        saveFavorites(){
		    let that = this
			console.log(that.dataSet)
            let parm = that.dataSet
            that.$http.urlpost('/User/SYS_Users/SaveFavoritesList', parm, function(res) {
                if (res.Success == 1) {
                    //that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            });
		},
		//编辑收藏
        editWebsite(row){
            let that = this
            that.editData = {
                website_id:row.website_id,
                website_address:row.website_address,
                website_name :row.website_name,
                type :row.type,
                login_num :row.login_num,
                login_name :row.login_name,
                pagename:row.pagename,
                colsort:row.colsort,
			}
            that.editVisible=true
        },
        confirmEditWebsite(){
			let that = this
			let parm = that.editData
            that.$http.urlpost('/User/SYS_Users/EditFavorites', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    that.editVisible=false
                    that.getView()
                }
            });
		},
        getRegUrl(url)
			{
                let that = this
				let arr = url.split('/')
				return arr[0]+arr[1]+arr[2];
			},
        confirmSetting(){
		    let that = this
			//判断是否有勾选项
			if(that.checkList.length == 0){
                that.showP = true
			} else {
                that.showP = false
			}
			let code = ''
			for(let i = 0;i<that.checkList.length;i++){
                code += that.checkList[i] + ','
			}
			code = code.substring(0,code.length-1)
			let parm = {
			    Code:code
			}
            that.$http.urlpost('/SaveHomeContent', parm, function (res) {
                if (res.Success == 1) {
                    that.setvisible = false
                    that.getHomeC()
                }
            });
		},
        changeECharts(){

		},
		getHomeC(){
		    let that = this
			let parm = {}
            that.checkList = []
            that.$http.urlpost('/GetHomeContent', parm, function (res) {
                if (res.Success == 1) {
                    that.checkListStr = res.DataContent
					if(that.checkListStr != ''){
                        that.checkList = that.checkListStr.split(',')
					} else {
                        that.checkList = []
					}
					if(that.checkListStr != ''){
                        that.showP = false
                        if(that.checkListStr.indexOf('日历') !== -1){
                            that.getCalendar(new Date().getFullYear() ,new Date().getMonth() + 1)
                        }
                        if(that.checkListStr.indexOf('强关工单') !== -1){
                            that.$nextTick(()=> {
                                that.getSoForceClose()
                            })
						}
                        if(that.checkListStr.indexOf('用料成本差异') !== -1){
                            that.$nextTick(()=> {
                                that.getCostVariance()
                            })
                        }
                        if(that.checkListStr.indexOf('活跃物料数量') !== -1){
                            that.$nextTick(()=> {
                                that.getPartMaterialStatics()
                            })
                        }
                        if(that.checkListStr.indexOf('OEE') !== -1){
                            that.$nextTick(()=> {
                                that.GetOEERate()
                            })
                        }
                        if(that.checkListStr.indexOf('板材利用率') !== -1){
                            that.$nextTick(()=> {
                                that.GetBoardRate()
                            })
                        }
                        if(that.checkListStr.indexOf('DPPM') !== -1){
                            that.$nextTick(()=> {
                                that.GetSalDPPMRate()
                            })
                        }
                        if(that.checkListStr.indexOf('会议') !== -1){
                            that.$nextTick(()=> {
                                that.GetMyConfList()
                            })
                        }
					} else {
                        that.showP = true
					}
                }
            });
		},
		// 获取日历数据
        getCalendar(year,month) {
            let that = this
			let parm = {
                tyear: year,
                tmonth: month
			}
            that.$http.urlpost('/Basic/WH/GetDayStatsuByProduce', parm, function (res) {
                if (res.Success == 1) {
                    let data = res.DataContent
                    if(data.length > 0){
                        that.calendardata = []
                        that.selectdate = null
                        const today = new Date()
                        const todayYear = today.getFullYear()
                        const todayMonth = today.getMonth()
                        const todayDay = today.getDate()
                        for(let i = 0;i<data.length;i++){
                            that.calendardata = [...that.calendardata,{
                                cd_date: data[i].cd_date,
                                year: new Date(data[i].cd_date).getFullYear(),
                                month:new Date(data[i].cd_date).getMonth() + 1,
                                day: new Date(data[i].cd_date).getDate(),
                                day_status: data[i].day_status,
                                lunar: that.$lunarcalendar.getDetailedLunar(data[i].cd_date)
                            }]
                            const itemDate = new Date(data[i].cd_date)
                            if(itemDate.getFullYear() === todayYear &&
                                itemDate.getMonth() === todayMonth &&
                                itemDate.getDate() === todayDay){
                                that.selectdate = itemDate
                            }
                        }
                    }
                    const calendarDays = document.querySelectorAll('.el-calendar-table .el-calendar-day');
                    const calendarHeader = document.querySelectorAll('.el-calendar-table thead th');
                    if(that.checkList.length == 1){
                        calendarDays.forEach(day => {
                            day.style.height = '';
                        });
                        calendarHeader.forEach(week => {
                            week.style.fontSize = '20px';
                        })
                    } else {
                        let height = (window.innerHeight - 200) /20
                        console.log('height' + height)
                        calendarDays.forEach(day => {
                            day.style.height = height + 'px';
                        });
                        calendarHeader.forEach(week => {
                            week.style.fontSize = '';
                        })
                    }
                    that.$nextTick(() => {
                        let btn1 = document.querySelector('.el-calendar-table thead th:nth-child(1)')
                        btn1.innerText = that.$t('getapi[6289]')
                        let btn2 = document.querySelector('.el-calendar-table thead th:nth-child(2)')
                        btn2.innerText = that.$t('getapi[6290]')
                        let btn3 = document.querySelector('.el-calendar-table thead th:nth-child(3)')
                        btn3.innerText = that.$t('getapi[6291]')
                        let btn4 = document.querySelector('.el-calendar-table thead th:nth-child(4)')
                        btn4.innerText = that.$t('getapi[6292]')
                        let btn5 = document.querySelector('.el-calendar-table thead th:nth-child(5)')
                        btn5.innerText = that.$t('getapi[6293]')
                        let btn6 = document.querySelector('.el-calendar-table thead th:nth-child(6)')
                        btn6.innerText = that.$t('getapi[6294]')
                        let btn7 = document.querySelector('.el-calendar-table thead th:nth-child(7)')
                        btn7.innerText = that.$t('getapi[6295]')
                    })
                }
            });
        },
        bindCalendarEvents() {
            // 如果监听器已经绑定过，则不再绑定
            if (this.calendarListenersBound) return;

            const calendarEl = this.$refs.calendarRef?.$el;
            if (!calendarEl) {
                console.warn('日历元素未找到');
                return;
            }

            // 使用 setTimeout 确保按钮已经渲染
            setTimeout(() => {
                this.bindButtons(calendarEl);
                this.calendarListenersBound = true;
            }, 100);
        },

        bindButtons(calendarEl) {
            // 点击前一个月
            let prevBtn = calendarEl.querySelector(
                '.el-calendar__button-group .el-button-group>button:nth-child(1)');

            if (prevBtn) {
                // 移除可能存在的旧监听器
                prevBtn.removeEventListener('click', this.handlePrevMonth);
                prevBtn.addEventListener('click', this.handlePrevMonth);
            }

            // 点击当月
            let currentBtn = calendarEl.querySelector(
                '.el-calendar__button-group .el-button-group>button:nth-child(2)');

            if (currentBtn) {
                currentBtn.removeEventListener('click', this.handleCurrentMonth);
                currentBtn.addEventListener('click', this.handleCurrentMonth);
            }

            // 点击后一个月
            let nextBtn = calendarEl.querySelector(
                '.el-calendar__button-group .el-button-group>button:last-child');

            if (nextBtn) {
                nextBtn.removeEventListener('click', this.handleNextMonth);
                nextBtn.addEventListener('click', this.handleNextMonth);
            }
        },
        handleCurrentMonth() {
		    let that = this
            let date = new Date();
            this.getCalendar(date.getFullYear(), date.getMonth() + 1);
        },
        handlePrevMonth() {
            let that = this;
            that.getCalendar(
                that.selectdate.getFullYear(),
                that.selectdate.getMonth() + 1
            );
        },

        handleNextMonth() {
            let that = this;
            that.getCalendar(
                that.selectdate.getFullYear(),
                that.selectdate.getMonth() + 1
            );
        },
        //强关工单
        getSoForceClose(){
		    let that = this
            let parm = {
                Code: new Date().getFullYear()
            }
            that.$http.urlpost('/Kpi/SoForceCloseMonthStatics', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent
                    if(that.data.length > 0){
                        let list = that.handle_qggd(that.data)
                        that.$nextTick(() => {
                            that.draw_qggd(list)
                        })

                    }
                }
            });
		},
        // 处理数据
        handle_qggd(dataContent){
            let that = this
            let list = {
                datax: [],
                data:[]
            }
            for(let i=0;i<dataContent.length;i++){
                list.datax = [...list.datax,dataContent[i].yearmonth]
                list.data = [...list.data,dataContent[i].percent]
            }
            return list;
        },
        // 图标
        draw_qggd(list){
            let that = this;
            that.charts = echarts.init(document.getElementById("main_qggd"));
            that.charts.resize();
            let option = {
                title: {
                    text: new Date().getFullYear() + "强关工单百分比",
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: list.datax
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    },
                },
                series: [{
                    data: list.data,
                    type: 'line',
                    smooth: true,
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
		//用料成本差异
        getCostVariance(){
            let that = this
            let parm = {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                type: 'desc'
            }
            that.$http.urlpost('/Kpi/CostVariance', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent
                    if(that.data.length > 0){
                        let list = that.handle_ylcb(that.data)
                        that.$nextTick(() => {
                            that.draw_ylcb(list)
                        })
                    }
                }
            });
		},
        // 处理数据
        handle_ylcb(dataContent){
            let that = this
            let data = [];
            let list = {
                datax: [],
                data:[],
            }
            for(let i=0;i<dataContent.length;i++){
                list.datax = [...list.datax,dataContent[i].itemCode]
                list.data = [...list.data,dataContent[i].difference]
            }
            return list;
        },
        // 图标
        draw_ylcb(list){
            let that = this;
            that.charts = echarts.init(document.getElementById("main_ylcb"));
            that.charts.resize();
            let option = {
                title: {
                    text: "BOM用料与实际用料之间成本差异（元）",
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: list.datax
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        axisLabel: {
                            formatter: '{value}'
                        },
                    },
                    {
                        type: 'value',
                        min: 0,
                        max: 100,
                        axisLabel: {
                            formatter: '{value}%'
                        },
                    },
                ],
                series: [{
                    data: list.data,
                    type: 'bar',
                    showBackground: true,
                    itemStyle:{
                        normal:{
                            color:'#409eff'
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
		//活跃物料数量
        getPartMaterialStatics(){
		    let that = this
            let parm = {
                Code: new Date().getFullYear()
            }
            that.$http.urlpost('/Kpi/PartMaterialStatics', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent
                    let d = that.handle_hywl(that.data)
                    that.$nextTick(() => {
                        that.draw_hywl(d)
                    })
                }
            });
		},
        // 处理数据
        handle_hywl(dataContent){
            let that = this
            let list = {
                datax:[],
                data1:[],
                data2:[],
                data3:[],
            }
            for(let i=0;i<dataContent.length;i++){
                list.datax = [...list.datax,dataContent[i].YearMonth]
                list.data1 = [...list.data1,dataContent[i].A]
                list.data2 = [...list.data2,dataContent[i].B]
                list.data3 = [...list.data3,dataContent[i].C]
            }
            return list;
        },
        // 图标
        draw_hywl(list){
            let that = this;
            that.charts = echarts.init(document.getElementById("main_hywl"));
            that.charts.resize();
            let option = {
                title: {
                    text: new Date().getFullYear() + "活跃物料数量统计",
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                legend: {
                    data: ['原材料', '产成品', '半成品'],
                    right: 10,
                    orient: 'vertical',
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: list.datax
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    },
                },
                series: [{
                    data: list.data1,
                    name:'原材料',
                    type: 'line',
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                },{
                    data: list.data2,
                    type: 'line',
                    name:'产成品',
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                },{
                    data: list.data3,
                    name:'半成品',
                    type: 'line',
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
        //OEE
        GetOEERate(){
            let that = this
            let parm = {
                "BeginDate": new Date().getFullYear() + '-01',
                "EndDate": new Date().getFullYear() + '-12'
            }
            that.$http.urlpost('/Kpi/GetOEERate', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent
                    that.$nextTick(() => {
                        that.draw_oee(that.data)
                    })
                }
            });
		},
        // 图标
        draw_oee(dataContent){
            let that = this;
            let list = {
                datax:[],
                data1:[],
                data2:[],
                data3:[],
                data1_oee: [],
                data1_day:[],
                data2_oee: [],
                data2_day:[],
                data3_oee: [],
                data3_day:[],
            }
            let tab = dataContent.Table
            let tab1 = dataContent.Table1
            let tab2 = dataContent.Table2
            for(let i=0;i<tab.length;i++){
                list.datax = [...list.datax,tab[i].ryear+'-'+tab[i].rmonth]
                list.data1 = [...list.data1,tab[i].oeeavg]
                list.data1_oee = [...list.data1_oee,{
                    key: tab[i].ryear+'-'+tab[i].rmonth,
                    val: tab[i].oee
                }]
                list.data1_day = [...list.data1_day,{
                    key: tab[i].ryear+'-'+tab[i].rmonth,
                    val: tab[i].totalday
                }]
            }
            for(let i=0;i<tab1.length;i++){
                list.data2 = [...list.data2,tab1[i].oeeavg]
                list.data2_oee = [...list.data2_oee,{
                    key: tab1[i].ryear+'-'+tab1[i].rmonth,
                    val: tab1[i].oee
                }]
                list.data2_day = [...list.data2_day,{
                    key: tab1[i].ryear+'-'+tab1[i].rmonth,
                    val: tab1[i].totalday
                }]
            }
            for(let i=0;i<tab2.length;i++){
                list.data3 = [...list.data3,tab2[i].oeeavg]
                list.data3_oee = [...list.data3_oee,{
                    key: tab2[i].ryear+'-'+tab2[i].rmonth,
                    val: tab2[i].oee
                }]
                list.data3_day = [...list.data3_day,{
                    key: tab2[i].ryear+'-'+tab2[i].rmonth,
                    val: tab2[i].totalday
                }]
            }
            that.charts = echarts.init(document.getElementById("main_oee"));
            that.charts.resize();
            let option = {
                title: {
                    text: "OEE",
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        let d = params
                        console.log(d)
                        let val1=''
                        let val2=''
                        if(d.seriesName == '折弯'){
                            for(let i = 0;i<list.data1_oee.length;i++){
                                if(params.name == list.data1_oee[i].key){
                                    val1 = list.data1_oee[i].val
                                }
                            }
                            for(let i = 0;i<list.data1_day.length;i++){
                                if(params.name == list.data1_day[i].key){
                                    val2 = list.data1_day[i].val
                                }
                            }
                        } else if(d.seriesName == '数冲'){
                            for(let i = 0;i<list.data2_oee.length;i++){
                                if(params.name == list.data2_oee[i].key){
                                    val1 = list.data2_oee[i].val
                                }
                            }
                            for(let i = 0;i<list.data2_day.length;i++){
                                if(params.name == list.data2_day[i].key){
                                    val2 = list.data2_day[i].val
                                }
                            }
                        } else if(d.seriesName == '激光'){
                            for(let i = 0;i<list.data3_oee.length;i++){
                                if(params.name == list.data3_oee[i].key){
                                    val1 = list.data3_oee[i].val
                                }
                            }
                            for(let i = 0;i<list.data3_day.length;i++){
                                if(params.name == list.data3_day[i].key){
                                    val2 = list.data3_day[i].val
                                }
                            }
                        }
                        return 'oee:'+val1 + '<br/>' + that.$t('getapi[12373]')+':'+val2;
                    }
                },
                legend: {
                    data: [that.$t('getapi[8675]'), that.$t('getapi[6262]'),that.$t('getapi[8673]')],
                    right: 10,
                    orient: 'vertical',
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: list.datax
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    },
                },
                series: [{
                    data: list.data1,
                    smooth: true,
                    name:that.$t('getapi[8675]'),
                    type: 'line',
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle:{
                        normal: {
                            lineStyle:{
                                width: 3
                            }
                        }
                    }
                },{
                    data: list.data2,
                    smooth: true,
                    type: 'line',
                    name:that.$t('getapi[6262]'),
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle:{
                        normal: {
                            lineStyle:{
                                width: 3
                            }
                        }
                    }
                },{
                    data: list.data3,
                    smooth: true,
                    name:that.$t('getapi[8673]'),
                    type: 'line',
                    stack:"",
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle:{
                        normal: {
                            lineStyle:{
                                width: 3
                            }
                        }
                    }
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
		//板材利用率
        GetBoardRate(){
            let that = this
            let parm = {
                "Code": new Date().getFullYear(),
            }
            that.$http.urlpost('Kpi/GetBoardRate', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent.Table
                    that.$nextTick(() => {
                        that.draw_bcly(that.data)
                    })
                }
            });
		},
        // 图标
        draw_bcly(dataContent){
            let that = this;
            let datax = [];
            let datay = []
            let data_qtyr = []
            let data_qty = []
            if (dataContent.length == 0) {
                //alert('没有数据');
                datax = [0,0,0,0,0,0,0,0,0,0,0,0]
                datay = [0,0,0,0,0,0,0,0,0,0,0,0]
            } else {
                for(let i = 0;i<dataContent.length;i++){
                    datax = [...datax,dataContent[i].year]
                    datay = [...datay,dataContent[i].rate]
                    data_qtyr = [...data_qtyr,{
                        key: dataContent[i].year,
                        val: dataContent[i].assist_coll_qtyr
                    }]
                    data_qty = [...data_qty,{
                        key: dataContent[i].year,
                        val: dataContent[i].assist_coll_qty
                    }]
                }
            }
            that.charts = echarts.init(document.getElementById("main_bcly"));
            that.charts.resize();
            let option = {
                title: {
                    text: new Date().getFullYear()+ that.$t('getapi[3460]'),
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        let d = params[0]
                        let val1=''
                        let val2=''
                        for(let i = 0;i<data_qtyr.length;i++){
                            if(params[0].axisValue == data_qtyr[i].key){
                                val1 = data_qtyr[i].val
                            }
                        }
                        for(let i = 0;i<data_qty.length;i++){
                            if(params[0].axisValue == data_qty[i].key){
                                val2 = data_qty[i].val
                            }
                        }
                        console.log(params[0])
                        return that.$t('getapi[12370]')+':'+val1 + '<br/>' + that.$t('getapi[12371]')+':'+val2;
                    }
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: datax
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    max: 100
                },
                series: [{
                    data: datay,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    itemStyle:{
                        normal:{
                            color:'#409eff'
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
        //DPPM
        GetSalDPPMRate(){
            let that = this
            let parm = {
                "Code": new Date().getFullYear(),
            };
            that.$http.urlpost('/Kpi/GetSalDPPMRate', parm, function (res) {
                if (res.Success == 1) {
                    that.data = res.DataContent.Table
                    that.$nextTick(() => {
                        that.draw_dppm(that.data)
                    })
                }
            });
		},
        // 图标
        draw_dppm(dataContent){
            let that = this;
            let datax = [];
            let datay = []
            if (dataContent.length == 0) {
                //alert('没有数据');
                datax = [0,0,0,0,0,0,0,0,0,0,0,0]
                datay = [0,0,0,0,0,0,0,0,0,0,0,0]
            } else {
                for(let i = 0;i<dataContent.length;i++){
                    datax = [...datax,dataContent[i].Finance_Date]
                    datay = [...datay,dataContent[i].rate]
                }
            }
            that.charts = echarts.init(document.getElementById("main_dppm"));
            that.charts.resize();
            let option = {
                title: {
                    text: new Date().getFullYear()+ 'DPPM',
                    x:'center',
                    y:'top',
                    textAlign:'left'
                },
                xAxis: {
                    type: 'category',
                    label: {
                        show: true,
                        position: 'insideRight'
                    },
                    data: datax
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    },
                },
                series: [{
                    data: datay,
                    type: 'bar',
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(220, 220, 220, 0.8)'
                    },
                    itemStyle:{
                        normal:{
                            color:'#409eff'
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }]
            }
            that.charts.clear();
            that.charts.setOption(option);
        },
		//我的会议
        GetMyConfList(){
		  	let that = this
			let parm = {}
            that.$http.urlpost('/Conf/View/MyConfList', parm, function(res) {
                if (res.Success == 1) {
                    that.dataMeeting = res.DataContent;
                    if(that.dataMeeting.length == 0){
                        that.dataMeeting = [{conf_room:'暂无会议'}]
					}
                }
            });
		},
        toMeetingRoom(row){
		    let that = this
			if(row.conf_room == '暂无会议'){
			    return false
			} else {
                let that = this
                that.$store.commit('setSharedParams',row);
                let item = {
                    label: this.$t('getapi[13295]'),
                    name: 'meetingroomlist',
                    path: '/meetingroomlist',
                    url: '/meetingroomlist',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/meetingroomlist'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
			}
		},
	}
};
</script>

<style lang="less" scoped>

//   .el-tag + .el-tag {
//     margin: 10px;
//   }
  .addfav {
    float: right;
    margin-top: 6px;
  }
  .jumpto{
	border: 0;
	span{
		font-weight: bold !important;
		margin-left: -6px;
		margin-right: -6px;
	}
  }
  .el-button--success.is-plain {
    color:#5f6265;
    background: #ffffff;
}
.el-button--success.is-plain:focus, .el-button--success.is-plain:hover{
	color: #67C23A;
}
  .favicon{
    margin-bottom: -6px;
  }
  /deep/.el-table th {
    padding: 3px 0!important;
  }


table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}


/deep/ .off {
	background: #dc0202;
}
/deep/ .work{
	background: black;
}
.offfont {
	color: #dc0202;
}
.lunar{
	color:#666
}
/deep/.el-calendar-table td.is-selected {
	background-color: #dc0202;
	color:#FFFFFF;
	.lunar{
		color:#FFFFFF
	}
	.offfont {
		color: #FFFFFF;
	}
}
/deep/ .el-calendar-table .el-calendar-day:hover {
	background: none;
}
/*/deep/ .workfont{
	color: #a8fff7;
}*/
/deep/.el-calendar-table {
	width: 100%;
	height: 100%;
	&:not(.is-range) {
		//使不是本月的日期不可点击，不会跳转到其他月份
		td.next {
			pointer-events: none;
		}
		td.prev {
			pointer-events: none;
		}
	}
}
/deep/.el-calendar__header{
	.el-calendar__title{
		font-size: 18px;
		margin-left: 45%;
	}
}
/deep/.el-calendar-table thead th:nth-child(6) {
	color: #dc0202;
}
/deep/.el-calendar-table thead th:nth-child(7) {
	color: #dc0202;
}
.el-carousel__item:nth-child(1) {
	background-color: #ff4955;
}

.el-carousel__item:nth-child(n+2) {
	background-color: #d3dce6;
}

.meeting-card {
	width: 100%;
	max-width: 300px; /* 缩小卡片宽度 */
	background: white;
	border-radius: 8px; /* 缩小圆角 */
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	overflow: hidden;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	transform: scale(0.7); /* 整体缩小为原来的70% */
}

.meeting-card:hover {
	transform: scale(0.72); /* 悬停时略微放大 */
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.card-header {
	background: linear-gradient(to right, #4776E6, #8E54E9);
	color: white;
	padding: 12px 15px; /* 缩小内边距 */
	text-align: center;
}

.card-header h2 {
	font-size: 0.5rem; /* 缩小字体大小 */
	font-weight: 600;
	margin-bottom: 3px;
}

.card-header p {
	opacity: 0.9;
	font-size: 0.35rem; /* 缩小字体大小 */
}

.card-content {
	padding: 15px; /* 缩小内边距 */
}

.info-row {
	display: flex;
	align-items: center;
	margin-bottom: 12px; /* 缩小间距 */
	padding-bottom: 8px; /* 缩小间距 */
	border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
	margin-bottom: 0;
	border-bottom: none;
}

.icon {
	width: 28px; /* 缩小图标容器 */
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px; /* 缩小间距 */
	font-size: 0.4rem; /* 缩小图标大小 */
	flex-shrink: 0;
}

.info-content {
	flex: 1;
}

.info-label {
	font-size: 0.3rem; /* 缩小字体大小 */
	color: #777;
	margin-bottom: 3px;
}

.info-value {
	font-size: 0.4rem; /* 缩小字体大小 */
	font-weight: 600;
	color: #333;
}

.theme .icon {
	background: rgba(142, 84, 233, 0.15);
	color: #8E54E9;
}

.time .icon {
	background: rgba(71, 118, 230, 0.15);
	color: #4776E6;
}

.person .icon {
	background: rgba(255, 107, 107, 0.15);
	color: #ff6b6b;
}

.phone .icon {
	background: rgba(72, 207, 173, 0.15);
	color: #48cfad;
}

@media (max-width: 480px) {
	.meeting-card {
		max-width: 300px;
	}

	.card-header {
		padding: 10px;
	}

	.card-content {
		padding: 12px;
	}

	.info-row {
		flex-direction: column;
		text-align: center;
	}

	.icon {
		margin-right: 0;
		margin-bottom: 8px;
	}
}
</style>
